<script setup lang="ts">
import type { FooterLink } from '.';

const links: FooterLink[] = [
  // { text: 'Cookies', url: '/cookies-notice' },
  // { text: 'GDPR', url: '/gdpr-notice' },
  { text: 'Obchodní podmínky', url: '/obchodni-podminky-1787820460517.pdf' },
];
const copyright = '© 2026 OKGYM - Všechna práva vyhrazena.';
</script>

<template>
  <div
    class="lg:px-r16 py-r6 lg:py-r12 gap-r12 lg:gap-r18 text-client-gray-darker flex flex-col-reverse items-center text-center lg:flex-row lg:text-start"
  >
    <AppParagraph>
      {{ copyright }}
    </AppParagraph>
    <div class="sm:gap-r4 lg:gap-r8 flex flex-col sm:flex-row">
      <AppLink
        v-for="(link, i) in links"
        :key="i"
        type="text"
        :to="link.url"
        :opts="{ link: { external: true, target: '_blank' } }"
      >
        {{ link.text }}
      </AppLink>
    </div>
  </div>
</template>
